<template>
	<div class="grid-content">
		<div class="date_search">
			<div class="search">
				<el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small" style="width: 100%;"
					:picker-options="pickerOptions" @change="searchChange">
				</el-date-picker>
			</div>
			<div class="sx">
				<div @click="sxDate(1)">15天</div>
				<div @click="sxDate(2)">30天</div>
				<div @click="sxDate">清空</div>
			</div>
		</div>
		<div class="chart">
			<fieldset v-loading="loading">
				<div style="width: 100%;height:18.75rem;" ref="order_chart"></div>
			</fieldset>
		</div>
		<div class="list" v-if="!loading && list.length>0">
			<el-row :gutter="20">
				<el-col :span="21">
					<el-table :data="list" border style="width: 100%;border-radius: 0;">
						<el-table-column width="160" label="日期">
							<template slot-scope="scope">
								{{scope.row.date}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="订单量" prop="order">
							<template slot-scope="scope">
								<span class="link" @click="lookOrder(scope.$index)">{{ scope.row.order }}</span>
								<span>笔</span>
							</template>
						</el-table-column>
						<el-table-column align="center" label="营业额" prop="amount">
							<template slot-scope="scope">
								{{ scope.row.amount }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="未付金额" prop="notactual">
							<template slot-scope="scope">
								<span v-if="scope.row.notactual!='0.00'"
									style="color: red;">{{ scope.row.notactual }}</span>
								<span v-else>{{ scope.row.notactual }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" label="信息费" prop="take">
							<template slot-scope="scope">
								{{ scope.row.take }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="司机收益" prop="actual">
							<template slot-scope="scope">
								{{ scope.row.actual }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="推广支出" prop="commission">
							<template slot-scope="scope">
								{{ scope.row.commission }}
							</template>
						</el-table-column>
						<el-table-column align="center" label="优惠支出" prop="coupon">
							<template slot-scope="scope">
								{{ scope.row.coupon }}
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="3">
					<el-link v-if="downurl" target="_blank" :href="downurl" :underline="false"
						style="margin-left:0.9375rem;">
						<el-button type="success">导出数据</el-button>
					</el-link>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	var orderChart;
	export default {
		data() {
			return {
				loading: true,
				query: {
					date: []
				},
				pickerOptions: {
					disabledDate: (time) => {
						const newDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
						return time.getTime() > newDate;
					}
				},
				downurl: null,
				list: []
			};
		},
		mounted() {
			orderChart = echarts.init(this.$refs.order_chart);
			this.initDate();
		},
		methods: {
			sxDate(t = 0) {
				const end = new Date();
				const start = new Date();
				switch (t) {
					case 1:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						this.postTotal();
						break;
					case 2:
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
						this.query.date = [this.$formatDay(start), this.$formatDay(end)];
						this.postTotal();
						break;
					default:
						this.initDate();
				}
			},
			initDate() {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
				this.query.date = [this.$formatDay(start), this.$formatDay(end)];
				this.postTotal();
			},
			searchChange(e) {
				if (this.query.date != null) {
					this.postTotal();
				}
			},
			onOrderEcharts() {
				const that = this;
				var date = [],
					order = [];
				var list = that.list;
				for (var i = 0; i < list.length - 1; i++) {
					date.push(list[i].date);
					order.push(list[i].order);
				}
				orderChart.setOption({
					color: ["#3fb1e4"],
					title: {
						text: '订单走势',
						textStyle: {
							fontSize: 15,
							color: "#404040"
						}
					},
					tooltip: {},
					xAxis: {
						data: date
					},
					yAxis: {},
					series: [{
						name: '订单量',
						type: 'line',
						data: order
					}]
				});
			},
			lookOrder(index) {
				const that = this;
				let list = that.list;
				let date = list[index].date;
				if (date == "总计") {
					let start = list[list.length - 2].date;
					let end = list[0].date;
					that.$router.push({
						name: "order_list_all",
						params: {
							query: {
								date: [start, end]
							}
						}
					});
				} else {
					that.$router.push({
						name: "order_list_all",
						params: {
							query: {
								date: [date, date]
							}
						}
					});
				}
			},
			postTotal() {
				const that = this;
				that.loading = true;
				that.$post('totalOrder', {
					date: that.query.date
				}).then(res => {
					setTimeout(function() {
						that.loading = false;
						that.list = res.data;
						that.onOrderEcharts();
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.chart fieldset {
		margin: 0;
		padding: 1.25rem 1.25rem 2rem;
		border: 1px #e6e6e6 solid;
	}

	.list {
		margin: 1.25rem 0;
	}

	.list>>>.el-table__body .el-table__row:last-child {
		font-weight: bold;
		background-color: #f2f5f9;
	}
</style>
